'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = _interopDefault(require('@narvar/nth-bit-paragraph'));

var Container = styled.div.withConfig({
  componentId: "sc-1ci29gf-0"
})(["text-align:center;"]);
var LandscapeContainer = styled.div.withConfig({
  componentId: "sc-1ci29gf-1"
})(["text-align:left;display:table-cell;vertical-align:middle;"]);
var PanelContentHeader = function PanelContentHeader(_ref) {
  var as = _ref.as,
    icon = _ref.icon,
    headerText = _ref.headerText,
    paragraphChildren = _ref.paragraphChildren,
    featureName = _ref.featureName,
    isLandscape = _ref.isLandscape;
  return isLandscape ? /*#__PURE__*/React.createElement(LandscapeContainer, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  }, icon), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'table-cell',
      verticalAlign: 'middle',
      padding: icon ? '0 1rem' : '0 1rem 0 0'
    }
  }, /*#__PURE__*/React.createElement(nthBitHeader.MediumHeader, {
    as: as,
    featureName: featureName
  }, headerText), /*#__PURE__*/React.createElement(Paragraph, {
    featureName: featureName,
    containerCustomStyle: {
      margin: '0.25rem 0 0 0'
    }
  }, paragraphChildren))) : /*#__PURE__*/React.createElement(Container, null, icon, /*#__PURE__*/React.createElement(nthBitHeader.MediumHeader, {
    as: as,
    featureName: featureName,
    containerCustomStyle: {
      margin: '1rem 0 0.5rem 0'
    }
  }, headerText), /*#__PURE__*/React.createElement(Paragraph, {
    featureName: featureName,
    containerCustomStyle: {
      margin: 0
    }
  }, paragraphChildren));
};
PanelContentHeader.defaultProps = {
  as: undefined,
  icon: undefined,
  headerText: undefined,
  paragraphChildren: undefined,
  featureName: undefined,
  isLandscape: undefined
};
PanelContentHeader.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div']),
  icon: PropTypes.node,
  headerText: PropTypes.string,
  paragraphChildren: PropTypes.node,
  featureName: PropTypes.string,
  isLandscape: PropTypes.bool
};

exports.default = PanelContentHeader;
